// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__R65FW","Cell":"EmployeeTable_Cell__Prw5P","Paper":"EmployeeTable_Paper__ReNyl"};